import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      name: '',
      cnpj: '',
      nomeFuncionario: '',
      cpf: '',
      email: '',
    }
  },
  mutations: {
    saveFisrtName(state, payload) {
      state.user.name = payload
    },
    saveFisrtcnpj(state, payload) {
      state.user.cnpj = payload
    },
    saveFisrtnomeFuncionario(state, payload) {
      state.user.nomeF = payload
    },
    saveFisrtcpf(state, payload) {
      state.user.cpf = payload
    },
    saveFisrtemail(state, payload) {
      state.user.email = payload
    },
  },
  actions: {
    saveFisrtName(context, payload) {
      context.commit('saveFisrtName', payload)
    },
    saveFisrtcnpj(context, payload) {
      context.commit('saveFisrtcnpj', payload)
    },
    saveFisrtnomeFuncionario(context, payload) {
      context.commit('saveFisrtnomeFuncionario', payload)
    },
    saveFisrtcpf(context, payload) {
      context.commit('saveFisrtcpf', payload)
    },
    saveFisrtemail(context, payload) {
      context.commit('saveFisrtemail', payload)
    },
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js